import { useEffect, useState } from "react"
import { WfmAbsence } from "../../../../services/actionsService"

const usePartDayAbsenceLogic = (
  wfmAbsence?: WfmAbsence
) => {
  const [partDayAbsence, setPartDayAbsence] = useState<boolean>(false)
  const [partDayAbsentFrom, setPartDayAbsentFrom] = useState<Date>(new Date())

  useEffect(() => {
    if (!wfmAbsence) {
      return
    }
    setPartDayAbsence(wfmAbsence.isPartDayAbsence)
    setPartDayAbsentFrom(new Date(wfmAbsence.absenceStartDate))
  }, [wfmAbsence])

  return {
    partDayAbsence,
    setPartDayAbsence,
    partDayAbsentFrom,
    setPartDayAbsentFrom,
  }
}

export default usePartDayAbsenceLogic